import { Col, Row } from 'antd'
import { Content } from 'antd/lib/layout/layout'
import React from 'react'
import { motion } from 'framer-motion'
import './Profile.css'
const profpic = require('../img/logo-AS1.png')
// const linkedin = require('../img/icon/linkedin.png')
// const link = {
//   linkedin: 'https://www.linkedin.com/in/albertsany/',
//   resume:
//     'https://drive.google.com/file/d/1ts9AXv-cfX9y0-LJCch2pNbvLl3bokfI/view?usp=share_link',
// }

const Profile = (param) => {
  return (
    <Content className="mainContent undraggable">
      <motion.div
        initial={{ x: 0, opacity: 0 }}
        transition={{ ease: 'easeIn', duration: 0.8 }}
        animate={{ opacity: [0, 1], x: [-100, 0] }}
      >
        <Row>
          <Col flex={1}>
            <motion.img alt="img" src={profpic} className="undraggable imgprofile" whileFocus={{ opacity: [0, 1], x: [-100, 0] }} />
            <h1 className="profileName">Hi, I'm Albert Sany </h1>
          </Col>

          {param.displaycaption ?
            (
              <Col flex={4}>
                <motion.div className="profileCaption" 
                style={{padding:window.innerWidth>1024 && "6px 240px"}}
                >
                  <p>
                   I’ve been in programming since 2019, developing websites and applications for a wide range of clients.<br/><br/>
                   Throughout my career, I have taken on diverse IT roles, delivering innovative ideas and tailored solutions that meet each client’s unique needs.
                  My work has consistently earned positive feedback, with clients satisfied by both the quality and functionality of the final product.
                    <br />
                  </p>
                  {/* <button className="white">open previous JobDesc</button>
                  <p>
                    My previous job description on PT.Trix Studio :
                  </p>
                  <ul className="white">
                    <li>Project Execution: <br />Execute projects based on client and user requirements with a focus on delivering high-quality solutions within established timelines.</li>
                    <li>Cross-Team Collaboration: <br /> Foster effective communication and collaboration with development teams through daily and weekly Scrum meetings to ensure project objectives are met with offline meetings and project management system JIRA and GitLab.</li>
                    <li>Debugging and Performance Optimization:  <br />Utilize advanced debugging techniques and conduct comprehensive performance testing to enhance system stability and efficiency.</li>
                  </ul> */}

                </motion.div>
              </Col>
            ): 
            (
              <Col flex={4}>
                <motion.div className="profileCaption" 
                style={{padding:window.innerWidth>1024 && "6px 10rem"}}
                >
                  <p>
                    Hi, I'm currently working as Videographer Freelancer since 2023, 
                    and I'm currently OPEN for providing creative services for Videographer, Video Editing wedding-prewedding, promotional video local brands, etc.  
                    <br />
                  </p>
                  {/* <p>
                    My daily-task : 
                  </p>
                  <ul className="white">
                    <li>Project Execution: <br />Working on handled projects and focus on delivering high-quality result within established timelines.</li>
                    <li>Cross-Team Collaboration: <br /> Foster effective communication and collaboration with creative teams.</li>
                  </ul> */}

                </motion.div>
              </Col>
            )
            }
        </Row>
      </motion.div>
    </Content>
  )
}

export default Profile
